import { Outlet } from 'react-router-dom';

const MobileLayout = () => (
  <div className="w-full flex justify-center">
    <div className="w-full mx-[24px] pb-6">
      <Outlet />
    </div>
  </div>
);

export { MobileLayout };
